<template>
    <vx-expandable-card>
        <template v-slot:header> Owner </template>
        <template v-slot:content>
            <div class="flex flex-col gap-4 mt-3">
                <div>
                    <vx-label size="md">First Name</vx-label>

                    <vx-input
                        data-test="first-name-input"
                        autofocus
                        v-model="firstName"
                        size="lg"
                        :error="displayFirstError(validate.first_name.$errors)"
                    ></vx-input>
                </div>

                <div>
                    <vx-label size="md">Last Name</vx-label>

                    <vx-input
                        data-test="last-name-input"
                        autofocus
                        v-model="lastName"
                        size="lg"
                        :error="displayFirstError(validate.last_name.$errors)"
                    ></vx-input>
                </div>
                <div>
                    <vx-label size="md">Email</vx-label>

                    <vx-input
                        data-test="email-input"
                        type="email"
                        autofocus
                        v-model="form.owner_email"
                        size="lg"
                        :error="displayFirstError(validate.owner_email.$errors)"
                    ></vx-input>
                </div>

                <div>
                    <vx-label size="md" class="w-full">
                        <div class="flex items-center justify-between grow">
                            <span>Phone Number</span>
                            <vx-badge color="slate" size="xs">
                                <span class="pb-[1.5px] text-xs leading-snug">Optional</span>
                                <font-awesome-icon widthAuto :icon="faPencilSlash" size="xs" />
                            </vx-badge>
                        </div>
                    </vx-label>

                    <vx-input
                        data-test="phone-input"
                        autofocus
                        v-model="form.owner_phone"
                        size="lg"
                        :error="displayFirstError(validate.owner_phone.$errors)"
                    ></vx-input>
                </div>
            </div>
        </template>
    </vx-expandable-card>
</template>
<script setup>
import { faPencilSlash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxExpandableCard, VxInput, VxLabel, VxBadge } from '@voxie/frontend-components';
import useVuelidate from '@vuelidate/core';
import { email, maxLength, required } from '@vuelidate/validators';
import { computed, ref, toRef, watch } from 'vue';
import { csvInjection, displayFirstError, phoneNumber } from '~/utils/validation';

const props = defineProps({
    externalResults: {
        type: Object,
        required: true,
    },
});

const form = defineModel({
    type: Object,
    required: true,
});

const firstName = ref('');
const lastName = ref('');

const validate = useVuelidate(
    {
        first_name: {
            required: required,
            csvInjection: csvInjection,
            maxLength: maxLength(59),
        },
        last_name: {
            required: required,
            csvInjection: csvInjection,
            maxLength: maxLength(60),
        },
        owner_email: {
            required: required,
            csvInjection: csvInjection,
            maxLength: maxLength(255),
            email: email,
        },
        owner_phone: {
            phoneNumber: phoneNumber,
        },
    },
    computed(() => ({
        first_name: firstName.value,
        last_name: lastName.value,
        ...form.value,
    })),
    { $externalResults: toRef(props, 'externalResults') }
);

watch([() => firstName.value, () => lastName.value], ([newFirstName, newLastName]) => {
    form.value.owner_name = `${newFirstName.trim()} ${newLastName.trim()}`;
});
</script>
